module.exports = __webpack_public_path__ + "static/media/kauSatelliteMap_final.aef2c7c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/kauSatelliteMap_final.jpg
// module id = 765
// module chunks = 0